module.exports = __webpack_public_path__ + "static/media/yesterdayImageMobile3.506cc890.png";